// extracted by mini-css-extract-plugin
module.exports = {"container":"_2fanS4","placeholder":"_3iEe74","hidden":"_26ezlO","placeholderImage":"_1lYMY3"};